import baseService from "@/services/Base-service";

class UserService {

  get controllerName() { return `/User/`; }

  listUsersByCompanySectionId(companySectionId) {
    return baseService.get(this.controllerName + 'ListUsersByCompanySectionId/' + companySectionId);
  }

  delete(Id) {
    return baseService.post(this.controllerName + 'DeleteUser/' + Id);
  }

  getDeleteUrl(itemId) {
    return this.controllerName + 'delete/' + itemId + '/' + (reason ?? "");
  }

  find(Id) {
    return baseService.get(this.controllerName + 'GetUser/' + Id);
  }

  create(model) {
    return baseService.post(this.controllerName + 'CreateUser', model);
  }

  update(model) {
    return baseService.post(this.controllerName + 'UpdateUsers', model);
  }

  updatePass(model) {
    return baseService.post(this.controllerName + 'UpdateUserPass', model);
  }

  updateCurrentUserPass(model) {
    return baseService.post(this.controllerName + 'UpdateCurrentUserPass', model);
  }

  getListByCompanyId(companyId) {
    return baseService.get(this.controllerName + 'GetUsersByCompany/' + companyId);
  }

  getListByCustomerId(customerId) {
    return baseService.get(this.controllerName + 'GetUsersByCustomer/' + customerId);
  }

  getUserRoles(userId) {
    return baseService.get(this.controllerName + 'GetUserRoles/' + userId);
  }

  modifyUserRoles(model, userId) {
    return baseService.post(this.controllerName + 'ModifyUserRoles/' + userId, model);
  }
}
export default new UserService();